import { Css, TextField, TextFieldApi } from "@homebound/beam";
import { useRef, useState } from "react";
import { Redirect, useLocation } from "react-router";
import { useDebouncedState } from "src/hooks";
import { useGlobalSearchModalQuery } from "src/routes/layout/GlobalSearchModal.generated";
import { StringParam, useQueryParams } from "use-query-params";
import { getGlobalSearchRow, GlobalSearchModalBody } from "../layout/GlobalSearchModal";

export function SearchPage() {
  const [params, setQueryParm] = useQueryParams({
    q: StringParam,
  });

  const [dirty, setDirty] = useState(false);
  const [search, debouncedSearch, setSearch] = useDebouncedState(params.q ?? "");
  const query = useGlobalSearchModalQuery({ variables: { search: debouncedSearch } });
  const location = useLocation();
  const textFieldApi = useRef<TextFieldApi | undefined>();

  const handleChange = (value: string | undefined) => {
    setSearch(value ?? "");
    setQueryParm({ q: value ?? "" });
    setDirty(true);
  };

  // If we receive a query from params and get only one result, just redirect to it
  // else if user types something, just behave as normal
  if (!dirty && query.data?.globalSearch?.length == 1) {
    const record = query.data.globalSearch[0].record;
    const row = getGlobalSearchRow(record, location);
    if (row) {
      return <Redirect to={row.primaryUrl} />;
    }
  }

  return (
    <>
      <div css={Css.bgWhite.br8.f1.w50.mt4.mxa.bshBasic.$}>
        <div css={Css.w100.df.fdc.gap1.p4.$}>
          <div css={Css.$}>
            <TextField
              autoFocus
              api={textFieldApi}
              label="Search"
              placeholder="Search"
              labelStyle="hidden"
              value={search}
              onChange={handleChange}
              xss={Css.xl2.$}
            />
          </div>
          <div>
            <span css={Css.xs.gray600.$}>↓ "Tab" down or type "123 Address", "PO 123", "TP Business"</span>
            {/* p1 so focus ring has space */}
            <div css={Css.df.fdc.p1.$}>
              <GlobalSearchModalBody records={query.data?.globalSearch.map((gsr) => gsr.record) ?? []} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
